export default "﻿<div>\n    <div>\n        <div data-dojo-attach-point=\"communicationObjectContainer\"></div>\n    </div>\n</div>\n"